import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { auth } from '@/FirebaseConfig'
import router from '@/router'
export default{
  namespaced: true,
  state: {
    sesion: false
  },
  actions: {
    iniciar_sesion: ({state}, {correo_electronico, contraseña}) => new Promise( async( resolver, rechazar) => {
      try{
        await auth.signInWithEmailAndPassword(correo_electronico, contraseña)
        state.sesion = true
        router.push({name:'contenido_cms'})
        resolver()
      } catch ( e ) {
        console.log(e)
        rechazar(e)
      }
    }),
    cerrar_sesion: ({state}) => new Promise ( async ( resolver, rechazar) => {
      try {
        await auth.signOut()
        state.sesion = false
        router.push({name:'iniciar_sesion'})
        resolver()
      } catch (e) {
        console.log(e)
        rechazar (e)
      }
    })
  }
}